$(document).ready(function () {
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 250) {
            $('#logo').addClass("small");

        } else {
            $('#logo').removeClass("small");
        }
    });
});